import { render, staticRenderFns } from "./PrintLandscape.vue?vue&type=template&id=4effe808"
import script from "./PrintLandscape.vue?vue&type=script&lang=ts"
export * from "./PrintLandscape.vue?vue&type=script&lang=ts"
import style0 from "./PrintLandscape.vue?vue&type=style&index=0&id=4effe808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports